<template>
  <div class="task">
    <!-- 任务管理 -->
    <div class="task-top">
      <span>
        <img src="../../assets/img/home-icon.png" alt="" class="home-icon-img">
        <router-link :to="{ name: 'home' }">首页</router-link>
      </span>&nbsp;/&nbsp;
      <span>
        任务管理
      </span>
      <el-button icon="el-icon-back" class="retrunbtn" type="text" @click="urlback" v-if="pid > 0">返回</el-button>
    </div>
    <div class="task-content">
      <div class="task-content-search">
        <span class="task-search-title">名称: </span>
        <el-input v-model="searchname" class="task-name-search" placeholder="请输入名称"></el-input>
        <span class="task-search-title">关联产品: </span>
        <el-select v-model="product_id" placeholder="请选择产品" class="task-relevancy">
          <el-option v-for="item in products" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button icon="el-icon-search" class="task-search-btn" @click="searchHandle">搜索</el-button>
      </div>
      <!--  -->
      <el-button icon="el-icon-plus" @click="addTaskHandle" class="add-task-btn">添加任务</el-button>
    </div>
    <!--  -->
    <div v-loading="loading" class="task-list item-list">
      <div class="task-item" v-for="item in taskData" :key="item.id">
        <div class="task-item-left">
          <!-- <el-checkbox v-model="item.chk"></el-checkbox> -->
          <div class="task-img-box">
            <img :src="resize(item.cover)" alt="" class="task-item-img" v-if="item.cover">
            <img src="../../assets/img/默认封面.png" alt="" class="task-item-img" v-else>
          </div>

          <div class="task-item-left-text">
            <el-tooltip class="box-item" effect="dark" :content="item.name" placement="right">
              <p><span class="task-item-title">任务名: </span><span class="task-item-data">{{ item.name }}</span></p>
            </el-tooltip>
            <!-- <p><span class="task-item-title">任务名: </span><span class="task-item-data">{{ item.name }}</span></p> -->
            <p><span class="task-item-title">产品名: </span><span class="task-item-data">{{ item.product.product_name
            }}</span></p>

          </div>
          <div class="task-item-left-text">
            <p><span class="task-item-title">视频数: </span><span class="task-item-data">{{ item.video_num }}</span></p>
            <p><span class="task-item-title">图片数: </span><span class="task-item-data">{{ item.image_num }}</span></p>
          </div>
          <div class="task-item-left-text">
            <p><span class="task-item-title">创建时间: </span><span class="task-item-data">{{ item.create_time }}</span></p>
            <p><span class="task-item-title">视频进度: </span>
              <span class="task-item-data" style="color: #006cff;cursor: pointer;"
                @click="urlto('/video/list', { taskname: item.name })">
                {{ item.finished_num }}/{{ item.plan_num }}
              </span>
            </p>
          </div>
        </div>
        <div class="task-item-right">

          <template v-if="item.state == 'Unfinished'">
            <el-button type="text" icon="el-icon-video-pause" @click="Cancel(item)">终止</el-button>
            <el-button type="text" icon="el-icon-edit"
              @click="urlto('/task/detail', { taskid: item.task_id })">修改</el-button>
            <span class="task-item-right-execute">执行中</span>
          </template>


          <template v-if="item.state == 'Cancel'">
            <el-button type="text" icon="el-icon-document"
              @click="urlto('/task/detail', { taskid: item.task_id })">详情</el-button>
            <span class="task-item-right-execute">已取消</span>
          </template>


          <template v-if="item.state == 'Finished'">
            <el-button type="text" icon="el-icon-edit"
              @click="urlto('/task/detail', { taskid: item.task_id })">修改</el-button>
            <span class="task-item-right-finish">已完成</span>
          </template>

        </div>
      </div>
    </div>
    <!--  -->
    <div class="task-bottom item-bottom">
      <div class="task-bottom-left">
        <!-- <el-checkbox v-model="checkAll">全选</el-checkbox>
        <el-button class="task-del-btn" @click="del">删除</el-button> -->
      </div>
      <div class="page-content">
        <el-pagination @current-change="handleCurrentChange" :current-page="current" :page-size="pageSize"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
    <!--  -->

  </div>
</template>

<script>
import { resize } from '../../assets/js/common';
export default {
  name: 'taskPage',
  data() {
    return {
      // 名称
      searchname: '',
      // 所属产品
      product_id: 0,
      products: [],
      // 数据
      taskData: [],
      // 分页
      current: 1,
      pageSize: 10,
      total: 0,
      productid: 0,
      pid: 0,
      loading: false,
    }
  },
  created() {
    var query = this.$route.query;
    this.pid = query.pid;
    if (this.pid) {
      this.product_id = Number(this.pid)
    }
    this.$get('/product/options?type=0').then(res => {
      this.products = res.data;
    })

    this.query();
  },
  methods: {
    resize(url) {
      return resize(url)
    },
    // 添加任务
    addTaskHandle() {
      this.urlto('/task/detail', { pid: this.product_id })
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.current = val;
      this.query();
    },
    // 搜索
    searchHandle() {
      this.current = 1;
      this.query();
    },
    // 详情
    particularsHandle() {
      this.$router.push({
        name: 'redact'
      })
    },
    query() {
      this.loading = true;
      this.$get('/task/list', {
        page: this.current,
        size: this.pageSize,
        search: this.searchname,
        product_id: this.product_id,
      }).then(res => {
        for (let i in res.data.data) {
          res.data.data[i].chk = false;
        }
        this.taskData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      })
    },
    del() {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var ids = this.$linq.from(this.taskData).where(w => w.chk == true).select(s => s.task_id).toArray();
        this.$post('/task/task_del', { ids: ids }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除完成');
            this.query();
          }
        })
      });
    },
    urlto(router, params) {
      let url = router + "?" + new URLSearchParams(params).toString();
      this.$router.push(url);
    },
    urlback() {
      this.$router.go(-1);
    },
    Cancel(row) {
      this.$confirm('视频生成进度将会终止，是否确定？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.$post('/task/cancel', { ids: [row.task_id] }).then(res => {
          this.$message.success("任务已终止");
          this.query();
        })
      })

    }
  },
  computed: {
    checkAll: {
      set(v) {
        this.taskData.forEach((item) => (item.chk = v))
      },
      get() {
        return this.taskData.every((item) => item.chk)
      }
    }
  }
}

</script>

<style scoped>
.task-top {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 16px 20px;
}

.task-top {
  color: #606266;
  font-size: 14px;
}

.task-top .home-icon-img {
  margin-right: 4px;
}

.task-top a {
  color: #606266;
}

.task-top a:hover {
  color: #006cff;
}

.task-content {
  background-color: #fff;
  box-sizing: border-box;
  padding: 20px 30px 14px 20px;
}

.task-content-search {
  box-sizing: border-box;
  padding: 16px 0;
  border-bottom: 1px dashed #e5e5e5;
}

.task-content-search .task-search-title {
  font-size: 14px;
  color: #333;
}

.task-name-search {
  width: 278px;
  height: 40px;
  margin-right: 16px;
  margin-left: 4px;
}

.task-name-search input {
  background-color: #fff;
  border: 1px solid #d9dde5;
  border-radius: 3px;
}

.task-relevancy {
  width: 278px;
  height: 40px;
  margin-right: 16px;
  margin-left: 4px;
}

.task-search-btn {
  width: 88px;
  height: 40px;
  background-color: #006cff !important;
  border-radius: 3px;
  color: #fff !important;
  margin-left: 10px;
  border: none;
  opacity: 1;
  transition: all 0.2s ease;
}

.task-search-btn:hover {
  opacity: 0.9;
}

.add-task-btn {
  width: 130px;
  height: 40px;
  background-color: #006cff !important;
  border-radius: 3px;
  color: #fff !important;
  border: none;
  margin-top: 14px;
  opacity: 1;
  transition: all 0.2s ease;
}

.add-task-btn:hover {
  opacity: 0.9;
}

.task-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 3px;
  padding: 20px;
  margin-top: 10px;
}

.task-item-left {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 修改 */
.task-item-left div:nth-child(2) {
  width: 200px;
}

.task-item-left div:nth-child(3) {
  width: 70px;
}

.task-item-img {
  max-width: 100%;
  display: block;
  max-height: 60px;
}


.task-item-title {
  color: #888;
  font-size: 13px;
  white-space: nowrap;
}

.task-item-data {
  color: #000;
  font-size: 14px;
  white-space: nowrap;

}

.task-item-left-text {
  margin-right: 20px;
}

.task-item-left-text p:first-child {
  margin-bottom: 4px;
}

.task-item-right {
  display: flex;
  align-items: center;
}

.task-item-right .task-item-right-execute {
  color: #ffa72e;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding-left: 50px;
}

.task-item-right .task-item-right-execute::before {
  content: '';
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ffa72e;
  margin-right: 3px;
}

.task-item-right .task-item-right-finish {
  color: #0db46e;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding-left: 50px;
}

.task-item-right .task-item-right-finish::before {
  content: '';
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #0db46e;
  margin-right: 3px;
}

.task-item-particulars {
  width: 90px;
  height: 32px;
  background-color: #e7f4ff !important;
  border: 1px solid #cde7ff;
  border-radius: 3px;
  color: #006cff !important;
  font-size: 14px;
  padding: 0;
  margin-left: 20px;
  transition: all 0.2s linear;
}

.task-item-particulars:hover {
  background-color: #006cff;
  color: #fff;
}

.task-bottom {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  box-sizing: border-box;
  padding: 10px 15px;
}

.task-bottom .el-pagination {
  color: #606266;
  font-weight: 400;
}

.task-bottom .el-pagination>>>button {
  border: 1px solid #d9d9d9 !important;
  border-radius: 3px;
  padding: 0;
  min-width: 28px !important;
}

.task-bottom .el-pagination .btn-next,
.el-pagination .btn-prev {
  background: center center no-repeat #FFF;
  background-size: 16px;
  cursor: pointer;
  margin: 0;
  color: #606266;
}

.task-bottom .el-pagination .el-select .el-input {
  width: 90px;
  margin: 0 5px;
}

.task-bottom .el-pagination>>>.el-pagination__jump {
  margin-left: 10px;
  font-weight: 400;
  color: #606266;
}

.task-del-btn {
  width: 74px;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.09);
  padding: 0;
  margin-left: 10px;
}

.task-bottom-left {
  margin-left: 14px;
}

.task-bottom-left>>>.el-checkbox__label {
  padding-left: 20px;
}

.task-item>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.task-item>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #006CFF;
  border-color: #006CFF;
}

.task-bottom>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.task-bottom>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #006CFF;
  border-color: #006CFF;
}

@media screen and (max-width:1024px) {
  .task-name-search {
    width: 230px;
  }

  .task-relevancy {
    width: 230px;
  }

  .task-item-left-text {
    margin-right: 25px;
  }

  .task-bottom {
    flex-wrap: wrap;

  }

  .task-bottom-left {
    margin-bottom: 10px;
  }

  .el-pagination {
    margin-left: 14px;
  }
}

/* 修改 */
.task-img-box {
  width: 100px;
  border-radius: 3px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.task-item-left-text p {
  height: 20px;
  width: 178px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* .task-list{
  height: 700px;
  overflow-y: auto;
} */

.task-list {
  height: calc(100vh - 375px);
}

/* @media screen and (max-width:1250px) {
  .task-list{
    height: 400px;
  }
} */
</style>